import React from 'react'
import styles from './Modal.module.css'
import { IoClose } from "react-icons/io5";


const Modal = ({ isOpen, onClose, children }) => {

    if (!isOpen) return null;

    return (
        <div>
            <div className={styles.modal}>
                <div className={styles.overlay}></div>
                <div className={styles.modal_btn_wrapper}>

                    <div className={styles.modal_content}>
                        <button className={styles.close_button} onClick={onClose}><IoClose /></button>
                        
                        <div className={styles.modal_body}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal